import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import BrianyCareLogo from "../../assets/auth/BrainyCare-Logo.jpg";
import { data } from "../data";
import axios from "axios";

const BladderUltrasoundviewPreliminary = () => {
  const { filename } = useParams();
  const [examData, setExamData] = useState(null);
 const fetchData = async () => {
      try {
   const response = await axios.post(
        `/v2/ag/v1/${window.getPracticeId()}/imaging/get-image/id`,
        { row_id: parseInt(filename, 10) }
      );
      
      if (response?.data?.data[0]) {
        const raw = response.data?.data[0];
        const parsedData = JSON.parse(raw.data);
        setExamData(parsedData);
      }
      } catch (error) {
        console.error("Error fetching exam data:", error);
      }
    };
  useEffect(() => {
    if (filename) fetchData();
  }, [filename]);
  const formatDate = (date) => {
    const parsed = dayjs(date);
    return parsed.isValid() ? parsed.format("MMM D, YYYY") : "";
  };

  return (
<div
  id={examData ? "report-ready" : undefined}
  className="p-6 bg-white min-h-screen w-full flex justify-center items-center"
>
  <div className="w-full max-w-3xl flex flex-col items-center border border-gray-300 rounded-md p-12 shadow-sm">
        {/* Header */}
        <div className="flex items-start w-full justify-center mb-6">
          <img src={BrianyCareLogo} alt="Logo" className="w-14 h-14 mr-3" />
          <div>
            <h1 className="text-xl font-bold text-start text-blue-600 leading-none">C-HIM</h1>
            <p className="text-sm font-semibold mt-1">
              Center for Hypertension & Internal Medicine
            </p>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-center font-bold text-base underline mb-6">
          BLADDER ULTRASOUND PRELIMINARY
        </h2>

        {examData ? (
          <>
              <div className="flex justify-start text-sm text-left w-full mb-4">
                                          <div className="grid grid-cols-[auto_20px_1fr] gap-x-2 gap-y-1">
                                            <span><strong>MR No#</strong></span>
                                            <span>:</span>
                                            <span>{examData.patientid}</span>
                                        
                                            <span><strong>Name</strong></span>
                                            <span>:</span>
                                            <span>{examData.pat_name}</span>
                                        
                                            <span><strong>Age</strong></span>
                                            <span>:</span>
                                            <span>{examData.age}</span>
                                        
                                            <span><strong>Exam Date</strong></span>
                                            <span>:</span>
                                            <span>{dayjs(examData.examDate).format("MM, DD, YYYY")}</span>
                                        
                                            <span><strong>Date of Birth</strong></span>
                                            <span>:</span>
                                            <span>{dayjs(examData.pat_dob).format("MMM D, YYYY")}</span>
                                        
                                            <span><strong>Provider</strong></span>
                                            <span>:</span>
                                            <span>{examData.providername}</span>
                                        
                                            
                                        
                                            <span><strong>Patients History</strong></span>
                                            <span>:</span>
                                            <span>{examData.history}</span>
                                          </div>
                                        </div>
        
                <div className="flex justify-start  text-sm text-left w-full mb-4">
             <div>

 <div><strong>Pre Bladder Vol :</strong> {examData.preBladderVol}</div>
                <div><strong>Post Bladder Vol :</strong> {examData.postBladderVol}</div>
                <div><strong>Sonographers Impression :</strong> {examData.impression}</div>

             </div>
            
               
            

             
            </div>
<div className="flex justify-end w-full">
  <div className="flex border w-full max-w-xl min-w-[250px] p-2">
    
    {/* Signature - left half */}
    <div className="w-1/2 pr-4 border-r border-gray-300 break-words whitespace-pre-wrap">
      <div className="font-semibold">{examData.signature}</div>
    </div>

    {/* Right half - fixed layout */}
    <div className="w-1/2 pl-4 text-sm text-left">
      <div>Digitally Signed by</div>
     <div>{examData?.createdby||''}</div>
         <div>{dayjs(examData.dateofservice).format("MM-DD-YYYY")}</div>
    </div>
    
  </div>
</div>

          </>
        ) : (
          <p className="text-center text-gray-500">Loading...</p>
        )}
      </div>
    </div>
  );
};

export default BladderUltrasoundviewPreliminary;
